import { GroupEntity } from '@backstage/catalog-model';
import { Progress } from '@backstage/core-components';
import { ScoreBoard } from './ScoreBoard';
import { ScoreBoardType } from './ScoreBoardType';
import { useEntity } from '@backstage/plugin-catalog-react';
import { useGetVulnerabilitiesScores } from './hooks/useGetVulnerabilitiesScores';

import { ScoreWithFixAndNoFix, useTeamList } from '@internal/ui-common';

export const VulnerabilitiesScoreBoard = () => {
  const { entity: departmentGroup } = useEntity<GroupEntity>();
  const { teams, isLoading } = useTeamList(departmentGroup);

  const { scores } = useGetVulnerabilitiesScores({
    teams: isLoading ? [] : teams,
  });

  if (isLoading || scores === undefined) {
    return <Progress />;
  }
  return (
    <ScoreBoard<ScoreWithFixAndNoFix>
      scores={scores}
      type={ScoreBoardType.VULNERABILITIES}
    />
  );
};
